function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.284 26.151h32.258c5.69 9.199 6.016 18.758 5.865 28.348H5.418c0-9.775 0-19.551 5.865-28.348z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.628 19.308h3.91v6.843h-3.91zm13.685 0h3.91v6.843h-3.91z",
  strokeWidth: 1.002,
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.588 2.49) scale(.97753)",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.025
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0 1 1 0 0 0)",
  cx: 36.299,
  cy: 36.402,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0 1 1 0 0 0)",
  cx: 36.299,
  cy: 20.913,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0 1 1 0 0 0)",
  cx: 30.37,
  cy: 28.657,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0 1 1 0 0 0)",
  cx: 31.977,
  cy: 23.89,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0 1 1 0 0 0)",
  cx: 31.977,
  cy: 33.424,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0 1 1 0 0 0)",
  cx: 38.315,
  cy: 28.657,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 41.111,
  cy: -36.402,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 41.111,
  cy: -20.913,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 47.039,
  cy: -28.657,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 45.433,
  cy: -23.89,
  rx: 1.761,
  ry: 1.76
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 45.433,
  cy: -33.424,
  rx: 1.761,
  ry: 1.76
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27.426,
  cy: 40.325,
  r: 12.187,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.969 7.094C19.511 6.998 12.822 8.204 3.951 11c0 0-1.625 3.831-1.955 5.865-.365 2.252 0 6.843 0 6.843h11.73v-6.843c9.383-4.09 18.484-3.727 27.37 0v6.843h11.73s.366-4.591 0-6.843C52.497 14.831 50.873 11 50.873 11 42.745 8.589 36.428 7.19 27.97 7.094z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M53 17c4.106 8.693.161 39.827-3.305 35.056"
}));

var SvgTelephone = function SvgTelephone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelephone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Telephone.496f4536.svg";
export { ForwardRef as ReactComponent };